import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../../components/CiscoUi';
import styles from './PushActionUpdateButton.module.css';
interface PushActionUpdateButtonProps {
  onClick: VoidFunction;
  isDisabled?: boolean;
}
export function PushActionUpdateButton({
  onClick,
  isDisabled,
}: PushActionUpdateButtonProps): ReactElement {
  const { t } = useTranslation();

  return (
    <Button
      className={styles.saveBtn}
      colour="secondary"
      onClick={onClick}
      size="small"
      disabled={isDisabled}
    >
      {t('topologies.push.pushUpdatesButtonText')}
    </Button>
  );
}
